import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArgoReorderArrowsHook from "../../common/ArgoReorderArrowsHook";
import Typography from "@mui/material/Typography";
import ArgoIconButtonHook from "../../common/ArgoIconButtonHook";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import FlagCircleIcon from '@mui/icons-material/FlagCircle';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import AccordionDetails from "@mui/material/AccordionDetails";
import {removeCategoryGroup, reorderCategoryGroup} from "../../../actions/categoryEditorActions";
import {getGroupTemplate} from "../../../actions/groupTemplateActions";
import {expanderCollapseAll, expanderCollapseSelected, expanderPreset} from "../../../actions/expanderActions";
import QuestionViewerExpandableHook from "../questions/QuestionViewerExpandableHook";
import ArgoTemplateListDividerHook from "../../common/ArgoTemplateListDividerHook";
import ArgoExpandCollapseButtonHook from "../../common/ArgoExpandCollapseButtonHook";
import statusFormatter from "../../../utilities/StatusFormatter";
import * as portalShared from "../../../portal/shared/metadataConstantsAndUtilities"
import * as expander from "../../../utilities/expander";
import * as groupType from "../../../constants/groupTypeLikertOrDefault";
import * as TEMPLATE from "../../../constants/templateConstants";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import Box from "@mui/material/Box";


const GroupViewerExpandableHook = (props) => {

    //const [allRequiredTemplatesLoadedFromGraphFlag, setAllRequiredTemplatesLoadedFromGraphFlag] = useState(false);
    const [groupKeysArray, setGroupKeysArray] = useState([]);
    const [groupTemplateObjects, setGroupTemplateObjects] = useState({});

    const dispatch = useDispatch();

    const defaultExpanderObj = {expanderSet: false, expandAll: true, expander: {}};
    
    // Redux state
    const groupTemplatesFromSelector = useSelector(state => state.groupTemplate);

    // Get expander state from Redux
    const reduxExpander = useSelector(state => {
        if (state.expander && state.expander[props.parentName])
        {
            // If expander has parent category
            if (props.parentKey) {
                // Is there an object with expanders
                if (Object.keys(state.expander[props.parentName].expander).length) {

                    // In case an expander was added
                    if (state.expander[props.parentName].expander.hasOwnProperty(props.parentKey)) {
                        if (state.expander[props.parentName].expander[props.parentKey].hasOwnProperty("groupExpanderObj")) {
                            return state.expander[props.parentName].expander[props.parentKey].groupExpanderObj;
                        } else {
                            return defaultExpanderObj;
                        }
                    } else {
                        return defaultExpanderObj;
                    }
                } else {
                    return defaultExpanderObj;
                }
            } else {
                return state.expander[props.parentName];
            }
        } else {
            return defaultExpanderObj;
        }
    });

    useEffect(() => {

        if (props.useGraph) {

            // Graphs are a constant, once loaded they will not be changed because they are NOT used on screens that have edit capabilities

            if (props.isShowGroups && props.groupGraph) {

                let groupGraphClone = portalShared.cloneObj(props.groupGraph);
                let groups = groupGraphClone.showGroups;

                let groupKeys = [];
                let groupObjs = {};
                for (let g = 0; g < groups.length; g++) {

                    groupKeys.push(groups[g].templateKey);

                    let questionKeys = [];
                    for (let q = 0; q < groups[g].questionTemplates.length; q++) {
                        questionKeys.push(groups[g].questionTemplates[q].templateKey);
                    }
                    groups[g].questionKeys = questionKeys; // Add groupKeys to the object
                    groupObjs[groups[g].templateKey] = groups[g];
                }

                setGroupKeysArray(groupKeys);
                setGroupTemplateObjects(groupObjs);

            } else if (props.categoryGraph["id"]) {
                let categoryGraphClone = portalShared.cloneObj(props.categoryGraph);
                let groups = categoryGraphClone.groupTemplates.filter((group) => group.visible === !props.isShowGroups);

                let groupKeys = [];
                let groupObjs = {};
                for (let g = 0; g < groups.length; g++) {

                    groupKeys.push(groups[g].templateKey);

                    let questionKeys = [];
                    for (let q = 0; q < groups[g].questionTemplates.length; q++) {
                        questionKeys.push(groups[g].questionTemplates[q].templateKey);
                    }
                    groups[g].questionKeys = questionKeys; // Add groupKeys to the object
                    groupObjs[groups[g].templateKey] = groups[g];
                }

                setGroupKeysArray(groupKeys);
                setGroupTemplateObjects(groupObjs);
                //setAllRequiredTemplatesLoadedFromGraphFlag(true);
            }

        } else {

            if (props.groupKeys?.length >= 0) {

                props.groupKeys.forEach(groupKey => {
                    dispatch(getGroupTemplate(groupKey, null));
                });

                setGroupKeysArray(props.groupKeys);
                setGroupTemplateObjects(groupTemplatesFromSelector);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(props.groupKeys), groupTemplatesFromSelector, props.categoryGraph]);


    useEffect(() => {
        // if (stateExpander.hasOwnProperty("QuestionnaireEditor") &&
        //     !stateExpander.QuestionnaireEditor.expander.hasOwnProperty(props.parentKey) &&
        //     props.parentKey !== "") {
        //         let tempCategoryArray = [];
        //
        //         Object.keys(stateExpander.QuestionnaireEditor.expander).forEach(key => {
        //             tempCategoryArray.push(key);
        //         });
        //         tempCategoryArray.push(props.parentKey);
        //
        //         dispatch(expanderPreset("QuestionnaireEditor", TEMPLATE.TYPE.CATEGORY, tempCategoryArray, categoryTemplatesFromSelector));
        // } else
        if (groupKeysArray.length && allRequiredTemplatesLoaded()) {
                setExpander(props);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    } , [JSON.stringify(groupKeysArray), groupTemplateObjects]);


    const setExpander = (props) => {

        if (allRequiredTemplatesLoaded() && !Object.keys(reduxExpander.expander).length) {

            dispatch(expanderPreset(props.parentName, TEMPLATE.TYPE.GROUP, groupKeysArray, groupTemplateObjects, props.parentKey))

            props.setStateCallback({
                groupsLoaded: true,
                groupTemplates: groupTemplateObjects
            });

        }

    };

    const allRequiredTemplatesLoaded = () => {

        let allTemplatesLoaded = (groupKeysArray.length && (groupKeysArray.every(key => Object.keys(groupTemplateObjects).includes(key))));
        return allTemplatesLoaded;
    };

    // Event handlers
    const onClickIconButtonReorder = (event, fieldName, index, depth, direction) => {
        event.stopPropagation(); // Keep accordion from expand/collapse
        dispatch(reorderCategoryGroup((direction === "up"), index));
    };

    const onClickIconButtonEdit = (groupTemplate, event) => {
        event.stopPropagation(); // Keep accordion from expand/collapse
        props.setStateCallback({
            openGroupEditor: true,
            groupTemplate: groupTemplate
        });
    };

    const onClickIconButtonRemove = (index, groupTemplateKey, event) => {
        event.stopPropagation(); // Keep accordion from expand/collapse
        dispatch(removeCategoryGroup(index));

        props.removeGroupCallback(groupTemplateKey);
    };

    const onClickIconButtonInfo = (groupTemplate, event) => {

        let selectedTemplate = groupTemplate; // Use template unless graph mode
        if (props.useGraph) {
            selectedTemplate = props.categoryGraph.groupTemplates.find(obj => {return obj.id === groupTemplate.id});
        }

        event.stopPropagation(); // Keep accordion from expand/collapse
        props.setStateCallback({
            openGroupReview: true,
            selectedGroupInfoKey: selectedTemplate.templateKey,
            selectedGroupInfoId: selectedTemplate.id,
            selectedGroupInfoTemplate: selectedTemplate,
            hidePortalPreview: false,
            showCategoryBackButton: false
        });
    };

    const onExpandChange = (groupTemplateKey, event) => {

        let parentKey = props.categoryTemplate.templateKey === "" ? "NewUnsavedCategory" : props.parentKey;

        dispatch(expanderCollapseSelected(props.parentName, TEMPLATE.TYPE.GROUP, groupTemplateKey, parentKey));
    };

    // -----------------------------------------------------------------------------------------------------------------
    // RENDER ----------------------------------------------------------------------------------------------------------
    // -----------------------------------------------------------------------------------------------------------------

    // const notAllTemplatesLoaded = (keys, templates) => {
    //     let notAllLoaded = false;
    //
    //     keys.forEach((key) => {
    //         if (!templates[key]) {
    //             notAllLoaded = true;
    //         }
    //     });
    //
    //     return notAllLoaded;
    // };
    //
    // if (props.useGraph) {
    //     if (!allRequiredTemplatesLoadedFromGraphFlag) {
    //         return null;
    //     }
    // } else if (notAllTemplatesLoaded(groupKeysArray, groupTemplateObjects)) {
    //     return null;
    // }

    if (!allRequiredTemplatesLoaded()) {
        return null;
    }

    let template;

    if (props.isShowGroups && props.groupGraph) {
        template = props.groupGraph;
    } else {
        template = props.useGraph ? props.categoryGraph : (props.categoryTemplate ?? {id: 12345678}); // In case in create mode;
    }

    return (
        <div key={"GroupViewerExpandable-container-div-categoryId-" + template.id}
             id={"GroupViewerExpandable-container-div-categoryId-" + template.id}
             style={{width: "100%", minWidth: 0}}>

            <div>&nbsp;</div>

            {/*// ===========================================================================================================*/}
            {/*// GROUP LIST DIVIDER */}
            {/*// ===========================================================================================================*/}

            <ArgoTemplateListDividerHook
                fileName="GroupViewerExpandable"
                parentsLabel="Category"
                childLabel={["group","groups"]}
                arrayLength={groupKeysArray.length}
                isShowGroups={props.isShowGroups}
            />

            {/*// ===========================================================================================================*/}
            {/*// GROUP EXPAND/COLLAPSE BUTTON  - NOTE: No expand/collapse button if group is Likert i.e. has answers  */}
            {/*// ===========================================================================================================*/}

            {(groupKeysArray.length > 1) && (
                <div style={{float: "right", width: 140}}>
                    <ArgoExpandCollapseButtonHook
                        fileName="GroupViewerExpandable"
                        expandAll={reduxExpander.expandAll}
                        onClick={() => dispatch(expanderCollapseAll(props.parentName, TEMPLATE.TYPE.GROUP, groupKeysArray, props.parentKey))}
                    />
                    <div>&nbsp;</div>
                </div>
            )}

            {/*// ===========================================================================================================*/}
            {/*// ASSIGNED GROUPS LIST */}
            {/*// ===========================================================================================================*/}

            <div id="GroupViewerExpandable-question-list-container-div" 
                 style={{display: "flex", alignSelf: "flex-start", flexDirection: "column", width: "100%", minWidth: 0, minHeight: "min-content"}}>
                {groupKeysArray.map((groupTemplateKey, index) => (
                    <div key={groupTemplateKey + index} 
                         id={"GroupViewerExpandable-question-container-div-" + groupTemplateKey + index} 
                         style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <Accordion key={"Accordion-" + groupTemplateKey}
                                   id={"GroupViewerExpandable-Accordion-" + groupTemplateKey}
                                   variant="outlined"
                                   disableGutters={true}
                                   onChange={(event) => {
                                       if (groupTemplateObjects[groupTemplateKey]?.questionKeys.length > 0) onExpandChange(groupTemplateKey, event)
                                   }}
                                   expanded={groupTemplateObjects[groupTemplateKey]?.questionKeys.length > 0 ?
                                       (reduxExpander.expander[groupTemplateKey]?.open ? reduxExpander.expander[groupTemplateKey].open : false) :
                                       false}
                                   sx={{width: "100%", minWidth: 850}}>
                            <AccordionSummary
                                key={"AccordionSummary-" + groupTemplateKey}
                                id={"GroupViewerExpandable-AccordionSummary-" + groupTemplateKey}
                                expandIcon={groupTemplateObjects[groupTemplateKey]?.questionKeys.length > 0 ?
                                    <ExpandMoreIcon style={{color: expander.ICON_COLOR}}/> :
                                    <HorizontalRuleIcon style={{ color: expander.ICON_COLOR }}/>
                                }
                                aria-controls="panel1-content"
                                sx={{
                                    height: "30px",
                                    backgroundColor: expander.ACCORDION_BG_COLOR,
                                    "&:hover": {backgroundColor: expander.ACCORDION_BG_COLOR_HOVER},
                                    "& .MuiAccordionSummary-content": {
                                        alignItems: "center",
                                        display: "flex",
                                        gap: 1, // small spacing between groups
                                        minWidth: 0,
                                    }
                                }}
                            >
                                {props.showIconButtonReorder && groupKeysArray.length > 1?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 80}}>
                                        <ArgoReorderArrowsHook
                                            fileName="GroupViewerExpandable"
                                            fieldName="container-div"
                                            onClick={onClickIconButtonReorder}
                                            index={index}
                                            arrayLength={groupKeysArray.length}
                                            isFirst={index === 0}
                                            isLast={index === (groupKeysArray.length -1)}
                                            upArrowColor={index === 0 ? expander.ICON_COLOR_HIDDEN : expander.ICON_COLOR}
                                            downArrowColor={index === (groupKeysArray.length - 1) ? expander.ICON_COLOR_HIDDEN : expander.ICON_COLOR}
                                        />
                                    </Box> : ""
                                }

                                <Box style={{display: "flex", alignItems: "center", minWidth: 34}}>
                                    <Typography>
                                        {statusFormatter(groupTemplateObjects[groupTemplateKey], 0, 0)}
                                    </Typography>
                                </Box>

                                <Box style={{display: "flex", alignItems: "center", minWidth: 65, flex: 1}}>
                                    <Typography variant="h6" component="div" style={{flexShrink: 0, paddingLeft: 5, minWidth: 65, color: expander.TEXT_COLOR_SECONDARY}}>Group:</Typography>
                                    <Typography variant="h6" component="div"
                                                style={{
                                                    flex: 1,
                                                    minWidth: 0,
                                                    maxWidth: 950,
                                                    paddingLeft: 10,
                                                    color: expander.TEXT_COLOR_PRIMARY,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}>
                                        {groupTemplateObjects[groupTemplateKey].name}
                                    </Typography>
                                </Box>

                                {groupTemplateObjects[groupTemplateKey].nameQualifier ?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 258}}>
                                        <Typography variant="h6" component="div" style={{flexShrink: 0, paddingLeft: 5, minWidth: 83, color: expander.TEXT_COLOR_SECONDARY}}>Qualifier:</Typography>
                                        <Typography variant="subtitle1" component="div"
                                                    style={{
                                                        flex: 1,
                                                        minWidth: 175,
                                                        maxWidth: 175,
                                                        paddingLeft: 10,
                                                        color: expander.TEXT_COLOR_PRIMARY,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    }}>
                                            {groupTemplateObjects[groupTemplateKey].nameQualifier}
                                        </Typography>
                                    </Box> : ""
                                }

                                {groupTemplateObjects[groupTemplateKey].questionGroupType === groupType.GROUP_TYPE_LIKERT ?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 0}}>
                                        <Typography variant="subtitle1" component="div"
                                                    style={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        paddingLeft: 10,
                                                        color: expander.TEXT_COLOR_PRIMARY,
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    }}>
                                            LIKERT
                                        </Typography>
                                    </Box> :
                                    Object.entries(groupTemplateObjects).some(([key, obj]) => obj.questionGroupType === groupType.GROUP_TYPE_LIKERT) ?
                                        <Box style={{display: "flex", alignItems: "center", minWidth: 0}}></Box> : ""
                                }

                                <Box style={{display: "flex", alignItems: "center", minWidth: 0}}>
                                    <Typography variant="subtitle1" component="div"
                                                style={{
                                                    flex: 1,
                                                    minWidth: 0,
                                                    paddingLeft: 10,
                                                    color: expander.TEXT_COLOR_SECONDARY,
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                }}>
                                        {"(Questions Assigned: " + (groupTemplateObjects[groupTemplateKey]?.questionKeys ? groupTemplateObjects[groupTemplateKey]?.questionKeys.length : "0") + ")"}
                                    </Typography>
                                </Box>

                                {((!groupTemplateObjects[groupTemplateKey].visible && groupTemplateObjects[groupTemplateKey].visible !== undefined)||(props.isShowGroups)) ?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                        <ArgoIconButtonHook
                                            fileName="GroupViewerExpandable"
                                            fieldName="ShowGroup"
                                            index={props.propIndex}
                                            tooltip="Show Group is not visible unless specific answers are selected."
                                            icon={<VisibilityOffIcon style={{color: portalShared.colorNameToHex('gray')}}/>}
                                        />
                                    </Box> :
                                    Object.entries(groupTemplateObjects).some(([key, obj]) => !obj.visible && obj.visible !== undefined) ?
                                        <Box style={{display: "flex", alignItems: "center", minWidth: 40}}></Box> : ""
                                }

                                {props.showIconButtonEdit ?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                        <ArgoIconButtonHook
                                            fileName="GroupViewerExpandable"
                                            fieldName="edit"
                                            onClick={(event) => onClickIconButtonEdit(groupTemplateObjects[groupTemplateKey], event)}
                                            index={props.propIndex}
                                            icon={<ModeEditIcon style={{color: expander.ICON_COLOR}}/>}
                                        />
                                    </Box> : ""
                                }

                                {props.showIconButtonRemove ?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                        <ArgoIconButtonHook
                                            fileName="GroupViewerExpandable"
                                            fieldName="remove"
                                            onClick={(event) => onClickIconButtonRemove(index, groupTemplateKey, event)}
                                            index={props.propIndex}
                                            icon={<HighlightOffOutlinedIcon
                                                style={{color: expander.ICON_COLOR}}/>}
                                        />
                                    </Box> : ""
                                }

                                {!groupTemplateObjects[groupTemplateKey].currentFlag ?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                        <ArgoIconButtonHook
                                            fileName="CategoryViewerExpandable"
                                            fieldName="CurrentFlag"
                                            index={props.propIndex}
                                            tooltip="Not the current version"
                                            icon={<FlagCircleIcon style={{color: "#E84343"}}/>}
                                        />
                                    </Box> :
                                    Object.entries(groupTemplateObjects).some(([key, obj]) => !obj.currentFlag) ?
                                        <Box style={{display: "flex", alignItems: "center", minWidth: 40}}></Box> : ""
                                }

                                {props.showIconButtonInfo ?
                                    <Box style={{display: "flex", alignItems: "center", minWidth: 40}}>
                                        <ArgoIconButtonHook
                                            fileName="GroupViewerExpandable"
                                            fieldName="info"
                                            onClick={(event) => onClickIconButtonInfo(groupTemplateObjects[groupTemplateKey], event)}
                                            index={props.propIndex}
                                            tooltip="Show Details"
                                            icon={<InfoOutlinedIcon style={{color: expander.ICON_COLOR}}/>}
                                        />
                                    </Box> : ""
                                }
                            </AccordionSummary>
                            <AccordionDetails key={"GroupViewerExpandable-AccordionDetails-" + groupTemplateKey}>

                                {/*// ===========================================================================================================*/}
                                {/*// ASSIGNED QUESTIONS LIST */}
                                {/*// ===========================================================================================================*/}

                                <QuestionViewerExpandableHook
                                    parentName={props.parentName}
                                    parentType={TEMPLATE.TYPE.GROUP}
                                    parentTemplate={groupTemplateObjects[groupTemplateKey]}
                                    questionKeys={groupTemplateObjects[groupTemplateKey]?.questionKeys}
                                    showIconButtonReorder={false}
                                    showIconButtonEdit={props.showIconButtonEdit}
                                    showIconButtonRemove={false}
                                    setStateCallback={props.setStateCallback}
                                    hidePortalPreview={groupTemplateObjects[groupTemplateKey].answerOptionTemplates.length !== 0}
                                    useGraph={props.useGraph}
                                    groupGraph={groupTemplateObjects[groupTemplateKey]}
                                />

                                <div>&nbsp;</div>
                            </AccordionDetails>
                        </Accordion>

                        {(reduxExpander.expander[groupTemplateKey]?.open) && <div id={"spacer-div-" + index}>&nbsp;</div>}
                    </div>
                ))}
            </div>
        </div>
    );
};

GroupViewerExpandableHook.defaultProps = {
    parentName: "",
    parentKey: "",
    groupOnlyExpanders: false,
    categoryTemplate: {},
    defaultExpanded: false,
    showIconButtonReorder: true,
    showIconButtonEdit: true,
    showIconButtonRemove: true,
    showIconButtonInfo: true,
    hidePortalPreview: false,
    useGraph: false,
    isShowGroups: false,
    removeGroupCallback: function () {}
};

GroupViewerExpandableHook.propTypes = {
    parentName: PropTypes.string,
    parentKey: PropTypes.string,
    groupOnlyExpanders: PropTypes.bool,
    categoryTemplate: PropTypes.object,
    groupKeys: PropTypes.array,
    showIconButtonReorder: PropTypes.bool,
    showIconButtonEdit: PropTypes.bool,
    showIconButtonRemove: PropTypes.bool,
    showIconButtonInfo: PropTypes.bool,
    setStateCallback: PropTypes.func,
    removeGroupCallback: PropTypes.func,
    hidePortalPreview: PropTypes.bool,
    questionTemplate: PropTypes.object, // Added to force re-render after edit
    index: PropTypes.number,
    useGraph: PropTypes.bool,
    categoryGraph: PropTypes.object,
    groupGraph: PropTypes.object,
    isShowGroups: PropTypes.bool
};

export default GroupViewerExpandableHook;